var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    { attrs: { row: "", wrap: "" } },
    [
      _c(
        "v-flex",
        {
          staticClass: "pr-1",
          attrs: { xs4: "", "data-ui-component": "Survey Count" },
        },
        [
          _c(
            "SummaryTile",
            { attrs: { title: "Surveys" } },
            [
              _vm._v("\n      " + _vm._s(_vm.numberOfSurveys) + "\n      "),
              _c("v-icon", [_vm._v("content_paste")]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        {
          staticClass: "px-1",
          attrs: { xs4: "", "data-ui-component": "First Survey Date" },
        },
        [
          _c(
            "SummaryTile",
            { attrs: { title: "From" } },
            [
              _vm._v("\n      " + _vm._s(_vm.firstSurveyDate) + "\n      "),
              _c("v-icon", [_vm._v("event")]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        {
          staticClass: "pl-1",
          attrs: { xs4: "", "data-ui-component": "Last Survey Date" },
        },
        [
          _c(
            "SummaryTile",
            { attrs: { title: "To" } },
            [
              _vm._v("\n      " + _vm._s(_vm.lastSurveyDate) + "\n      "),
              _c("v-icon", [_vm._v("event")]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }